import Base from "../composition/Base";
import Rule, { RuleData, RuleResult } from "./Rule";
import ActionableRule from "./ActionableRule";
import type { Action } from "./Action";


export interface RulesetData {
    rules: RuleData[]
}

export default class Ruleset {
    private rules: (Rule | ActionableRule)[]

    constructor(rulesetData: RulesetData, element: Base) {
        let rulesInstatiatend = rulesetData.rules.map(r => {
            if ((r as any).type && (r as any).type == "actionable") {
                return new ActionableRule(r, element)
            } else {
                return new Rule(r, element)
            }
        })

        this.rules = rulesInstatiatend
    }

    evaluate() {
        for (var rule of this.rules) {

            if (rule instanceof ActionableRule) {
                continue;
            }

            const result = rule.evaluate()
            if (result == RuleResult.accept) {
                return result
            } else if (result == RuleResult.reject) {
                let errorCustom = new Error("Rule failed: " + rule.getReason());
                //@ts-ignore
                errorCustom.data = rule.getReason();

                throw errorCustom
            }
        }
    }

    evaluateActionRules(): Array<Action> {
        let actions: Array<Action> = [];

        for (var rule of this.rules) {
            if (!(rule instanceof ActionableRule)) {
                continue;
            }

            const result = rule.evaluate();
            if (result) {
                actions.push(result);
            }
        }

        return actions;
    }

}